"use client";
import React, { useEffect, useState } from 'react';
import './FormStep3.css';
import PropTypes from 'prop-types';
import { Check, Input, Select } from 'atm-global-stylish/dist';
import PhoneInput from '../basic/PhoneInput/PhoneInput';
import { isEmpty } from '../../utils/functions';
import { INPUT_CLASSNAME, SELECT_CLASSNAME } from '../../config/constants';

const ClaimantDataForm = ({ errors, formData, handleChange, type, options_claim_start }) => {
  const [list, setList] = useState([
    { value: "", title: 'Seleccionar *' },
    { value: '1', title: 'Sí' },
    { value: '0', title: 'No' },
  ]);
  const [damnificado, setDamnificado] = useState('');
  const [claimStart, setClaimStart] = useState('');

  useEffect(() => {
    if (formData?.who_start_the_claim !== '' && formData?.who_start_the_claim === '0') {
      setDamnificado('si')
    } else if (formData?.who_start_the_claim !== '' && formData?.who_start_the_claim !== '0') {
      setDamnificado('no')
    } else {
      setDamnificado('')
    }
  }, [formData.who_start_the_claim]);

  useEffect(() => {
    if (isEmpty(formData.who_start_the_claim)) {
      setClaimStart('');
    } else {
      setClaimStart(formData.who_start_the_claim);
    }
  }, [formData.who_start_the_claim]);

  useEffect(() => {
    if (type) {
      switch (type) {
        case '0':
          return;
        case '1':
          setList(prev => prev.map((item, i) => i === 0 ? { ...item, title: '¿El reclamante es el dueño del rodado? *' } : item));
          break;
        case '4':
          setList(prev => prev.map((item, i) => i === 0 ? { ...item, title: '¿El reclamante es el dueño del inmueble? *' } : item));
          break;
        case '2':
        case '3':
          setList([
            { value: "", title: "¿El reclamante es el titular del vehiculo? *" },
            { value: '1', title: 'Sí' },
            { value: '0', title: 'No' },
          ]);
          break;
        default:
          break;
      }
    }
  }, [type]);

  const handleSelect = (option) => {
    setDamnificado(option);
    if (option === 'si') {
      handleChange('who_start_the_claim')({ target: { value: '0' } })
    }
  }

  return (
    <>
      <div className='w-full md:mb-10 flex justify-center flex-col items-center'>
        <h2 className='text-2xl text-red font-semibold mt-4 w-full text-center'>¿Sos el damnificado?</h2>
        <div className="flex flex-col md:flex-row w-full justify-center gap-8 md:gap-10 mb-5 md:mb-0 mt-6 md:mt-8">
          <label className="flex flex-row gap-3 mt-4 cursor-pointer items-center justify-center">
            <p className="text-md">Sí, soy</p>
            <input
              type="checkbox"
              checked={damnificado === "si"}
              onChange={() => handleSelect("si")}
              className={`
              appearance-none w-5 h-5 border-2 border-red rounded-full cursor-pointer
              checked:bg-red checked:border-red
            `}
            />
          </label>
          <label className="flex flex-row gap-3 mt-4 cursor-pointer items-center justify-center">
            <p className="text-md">No, soy su representante</p>
            <input
              type="checkbox"
              checked={damnificado === "no"}
              onChange={() => handleSelect("no")}
              className={`
              appearance-none w-5 h-5 border-2 border-red rounded-full cursor-pointer
              checked:bg-red checked:border-red
            `}
            />
          </label>
        </div>
      </div>
      {damnificado !== '' &&
        <>
          {damnificado === 'no' &&
            <>
              <div className='w-full flex flex-col gap-5 my-4'>
                <div className='flex flex-1/2 md:w-full justify-between gap-5 md:gap-10'>
                  <Select
                    list={options_claim_start}
                    onChange={handleChange('who_start_the_claim')}
                    selectedValue={String(claimStart)}
                    className={`${!errors.who_start_the_claim ? 'text-grey-tx' : 'text-shiny-pink'} ${SELECT_CLASSNAME}`}
                  />
                </div>
                <div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10'>
                  <Input type='text' value={formData.contact_name} handleChange={handleChange('contact_name')} placeholder='Nombre y Apellido / RAZON SOCIAL' className={`${!errors.contact_name ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
                  <Input type='number' value={formData.contact_cuit}
                    maxLength={11}
                    handleChange={(e) => {
                      const onlyNumbers = e.target.value.replace(/\D/g, '');

                      if (onlyNumbers.length <= 11)
                        handleChange('contact_cuit')({ target: { value: onlyNumbers } })
                      else
                        return
                    }} placeholder='CUIT / CUIL / DNI' className={`${!errors.contact_cuit ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} />
                </div>
                <div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10'>
                  <Input type='text' value={formData.contact_addr} handleChange={handleChange('contact_addr')} placeholder='Domicilio' className={`${!errors.contact_addr ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
                  <PhoneInput
                    handleChange={handleChange}
                    prefix={'contact_'}
                    className={`${!errors.contact_phone ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
                  />
                </div>
                <div className='flex flex-row w-full md:w-1/2 justify-between gap-10'>
                  <Input type='email' value={formData.contact_mail} handleChange={handleChange('contact_mail')} placeholder='Correo Electronico' className={`${!errors.contact_mail ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} maxLength={100} regex={/^[a-zA-Z0-9@._\-,]*$/} />
                </div>
              </div>
              <h2 className='text-xl text-red font-semibold mt-8 w-full text-center'>Datos del damnificado</h2>
            </>
          }

          <div className='w-full flex flex-col md:gap-5 md:my-4'>
            <div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10 mb-5 md:mb-0'>
              <Input type='text' value={formData.claimant_vehicle_name} handleChange={handleChange('claimant_vehicle_name')} className={`${!errors.claimant_vehicle_name ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} placeholder='Nombre y Apellido / RAZON SOCIAL *' maxLength={100} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
              <Input type='number' maxLength={11} value={formData.claimant_vehicle_dni} handleChange={(e) => {
                const onlyNumbers = e.target.value.replace(/\D/g, '');

                if (onlyNumbers.length <= 11)
                  handleChange('claimant_vehicle_dni')({ target: { value: onlyNumbers } })
                else
                  return
              }} className={`${!errors.claimant_vehicle_dni ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} placeholder='CUIT / CUIL / DNI *' />
            </div>

            <div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10 mb-5 md:mb-0'>
              <Input type='text' value={formData.claimant_vehicle_address} handleChange={handleChange('claimant_vehicle_address')} className={`${!errors.claimant_vehicle_address ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} placeholder='Domicilio *' maxLength={50} regex={/^[a-zA-Z0-9 @.\-,]*$/} />
              <PhoneInput
                handleChange={handleChange}
                prefix={'claimant_vehicle_'}
                className={`${!errors.claimant_vehicle_phone ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`}
              />
            </div>

            <div className='flex flex-col md:flex-row w-full justify-between gap-5 md:gap-10'>
              <Input type='email' value={formData.claimant_vehicle_mail} handleChange={handleChange('claimant_vehicle_mail')} className={`${!errors.claimant_vehicle_mail ? 'input' : 'incomplete'} ${INPUT_CLASSNAME}`} placeholder='Correo electronico *' maxLength={100} regex={/^[a-zA-Z0-9@._\-,]*$/} />
              <div className='w-full'>
                {type !== '0' &&
                  <Select
                    list={list}
                    className={`${SELECT_CLASSNAME} ${!errors.claimant_person_is_vehicle_owner ? 'text-grey-tx' : 'text-shiny-pink'}`}
                    onChange={handleChange('claimant_person_is_vehicle_owner')}
                    selectedValue={String(formData.claimant_person_is_vehicle_owner)}
                  />
                }
              </div>
            </div>


          </div>
        </>
      }
      {Object.keys(errors).length > 0 && (
        <p className="text-pink text-sm text-center mb-4">(*) Los campos marcados son obligatorios.</p>
      )}
    </>
  );
};

ClaimantDataForm.propTypes = {
  errors: PropTypes.object,
  formData: PropTypes.object,
  handleChange: PropTypes.func,
  type: PropTypes.string
};

export default ClaimantDataForm;
